import { Avatar, Box, Button, Card, CardContent, Container, Divider, List, ListItem, ListItemAvatar, ListItemText, Paper, Typography } from "@mui/material";
import { styled } from '@mui/material/styles';
import Masonry from '@mui/lab/Masonry';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CustomHeader from "../components/common/custom-header.component";
import useUserProfile from "../../plugins/ProfilePlugin/hooks/useUserProfile";
import { useEffect, useState } from "react";


const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(0.5),
    textAlign: 'center',
    color: (theme.vars || theme).palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }));

export default function SelectProfile () {

    const {getProfile, profileDetails, loading} = useUserProfile();

    const [selectedIndex, setSelectedIndex] = useState(null);

  const handleListItemClick = (index) => {
    setSelectedIndex(index);
  };

    useEffect(() => {
        getProfile()
    },[])

    return(
        <Container maxWidth="lg" sx={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh'}}>
            
            <Paper elevation={0} sx={{width: "50%", overflow: "hidden", border: "1px solid #e5edf6", boxShadow: "none", borderRadius: 1, p: 5,}}>
            <CustomHeader headerText={"Select Profile"}/>
                <Box
                    sx={{
                    height: 400, // Set your desired fixed height
                    overflowY: 'auto',
                    pr: 1, // padding right for scrollbar
                    mt: 5
                    }} 
                >
                <Masonry columns={{ xs: 1, sm: 1}}>
                    {profileDetails?.map((data, index)=>(
                        <List Item={index} sx={{ width: '100%', bgcolor: 'background.paper', p: 0, m: 0 }}>
                            <ListItem divider selected={selectedIndex === index}
                            onClick={() => handleListItemClick(index)} sx={{
                                bgcolor: selectedIndex === index ? 'primary.main' : 'background.paper',
                                color: selectedIndex === index ? 'primary.contrastText' : 'text.primary',
                                // '&:hover': {
                                //   bgcolor: selectedIndex === index ? 'primary.dark' : 'action.hover',
                                // },
                              }}>
                                <ListItemAvatar>
                                <Avatar>
                                    <AccountCircleIcon />
                                </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={<Typography sx={{fontSize: 12}}>{data.profile_type}</Typography>} secondary={<Typography sx={{fontSize: 16, fontWeight:'bold'}}>{data.role}</Typography>} />
                            </ListItem>
                        </List>
                    ))}
                </Masonry>
                </Box>
                <Box sx={{ mt: 4, textAlign: 'end' }}>
                    <Button
                    variant="contained"
                    color="primary"
                    // onClick={handleSubmit}
                    disabled={selectedIndex === null}
                    >
                    Submit
                    </Button>
                </Box>
            </Paper>
        </Container>
    )
}